$(function () {
  // Color picker → hex input
  $(document).on("input", "#background_color_picker", function () {
    $("#background_color_hex").val($(this).val().toUpperCase());
  });

  // Hex input → color picker
  $(document).on("input", "#background_color_hex", function () {
    const val = $(this).val().trim();
    if (/^#[0-9A-Fa-f]{6}$/.test(val)) {
      $("#background_color_picker").val(val);
      $(this).css("border-color", "");
    } else {
      $(this).css("border-color", "red");
    }
  });

  // On blur, restore valid value if input is invalid
  $(document).on("blur", "#background_color_hex", function () {
    const val = $(this).val().trim();
    if (!/^#[0-9A-Fa-f]{6}$/.test(val)) {
      $(this).val($("#background_color_picker").val().toUpperCase());
      $(this).css("border-color", "");
    }
  });

  // Copy button
  $(document).on("click", "#copy-color-btn", function () {
    const el = $("#background_color_hex")[0];

    writeText(el.value)
      .then(function () {
        showFeedback();
      })
      .catch(function () {
        iosFallbackCopy(el);
      });
  });

  function showFeedback() {
    const $feedback = $("#copy-color-feedback");
    $feedback.fadeIn(150);
    setTimeout(function () {
      $feedback.fadeOut(300);
    }, 2000);
  }

  function iosFallbackCopy(el) {
    var oldContentEditable = el.contentEditable,
      oldReadOnly = el.readOnly,
      range = document.createRange();

    el.contentEditable = true;
    el.readOnly = false;
    range.selectNodeContents(el);

    var s = window.getSelection();
    s.removeAllRanges();
    s.addRange(range);

    el.setSelectionRange(0, 999999);

    el.contentEditable = oldContentEditable;
    el.readOnly = oldReadOnly;

    document.execCommand("copy");
    showFeedback();
  }
});
